<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="attendee.name"
                  v-model="attendee.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('attendees.name')"
                  :error-messages="errors.collect('attendee.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "TaskTypesForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      attendee: {},
      addresses: [],
      dictionary: {
        attributes: {
          "attendee.name": this.$t("attendees.name"),
          "attendee.address_id": this.$t("attendees.address_id")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.attendee, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("attendees.new_attendee")
      this.attendee = {}

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.attendee))
    } else {
      this.title = this.$t("attendees.update_title")

      axios
        .get(this.API_URL + "attendee/" + this.id)
        .then((res) => {
          this.attendee = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.attendee))

          this.page_title = this.$t("attendees.edit_attendee")
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.attendee.id) {
              // Create
              axios
                .post(this.API_URL + "attendee", {
                  name: this.attendee.name,
                  address_id: this.attendee.address_id,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.attendee = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.attendee))

                      vm.$awn.success(vm.$t("global.create_success"))
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "attendee", {
                  id: this.attendee.id,
                  name: this.attendee.name,
                  address_id: this.attendee.address_id
                })
                .then((res) => {
                  vm.attendee = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.attendee))

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped></style>
